import { apiRequest } from './apiClient';
import type { SessionReportResponse } from '../../types/report';

/** The canonical per-session report (D0): `GET /api/reports/{sessionId}`. */
export const reportAPI = {
  get: (sessionId: number) =>
    apiRequest<SessionReportResponse>({ endpoint: `/reports/${sessionId}`, method: 'GET' }),
};
